type checkboxOption = {
  label: string;
  value: string;
  toolTip?: string;
};

export enum NOTIFICATION_TYPES {
  AI_ALERT,
  AUTO_INSIGHT,
}

/**
 * some constants for the AUTO INSIGHTS
 */
export const AUTO_INSIGHT_NOTIFICATION_CATEGORY = 'Auto Insights';
export const AUTO_INSIGHT_TYPE = 'autoInsights';
// These are all the supported auto insight subscription categories
// If we want to support more we could add more items in it
export const AUTO_INSIGHT_NOTIFICATION_ITEMS_MAP = [
  {
    name: 'broken_assets', // this value is stored in the db
    displayName: 'Broken Assets', // this is the FE display name
    type: AUTO_INSIGHT_TYPE,
  },
];

export const SEVERITY_MAP: Array<checkboxOption> = [
  {
    label: 'Info and above',
    value: 'info',
  },
  {
    label: 'Warning and above',
    value: 'warning',
  },
  {
    label: 'Critical',
    value: 'critical',
  },
];

export const AUTO_INSIGHT_MAP: Array<checkboxOption> = [
  {
    label: 'All',
    value: 'all',
    toolTip: 'New & Previous',
  },
  {
    label: 'New',
    value: 'new',
    toolTip: 'Detected in latest batch',
  },
];

export const getSeverityMap = () => {
  return {
    EI: SEVERITY_MAP,
    APP: SEVERITY_MAP,
    AI: [{ label: 'Info and above', value: 'info' }],
  };
};

export const getOptionMap = () => AUTO_INSIGHT_MAP;
